export const normalizeText = (value: string) =>
  value
    .trim()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

export const compareText = (a: string, b: string) =>
  normalizeText(a).localeCompare(normalizeText(b), undefined, {
    sensitivity: "base",
    numeric: true,
  });
